import Vue from 'vue';
import Component from 'vue-class-component';
import { SPLASH_SCREEN_EVENTS } from '../../enum/splash-screen.enum';

@Component({ 
  name: 'ed-splash-screen'
})
export default class EdSplashScreen extends Vue {

  public isShown: boolean = false;
  public hidden: boolean = false;

  get spinner() {
    return this.$SplashScreen.spinner;
  }

  get message() {
    return this.$SplashScreen.message;
  }

  get splashClasses() {
    return {
      'ed-splash-screen--is-shown': this.isShown,
      'ed-splash-screen--is-hidden': this.hidden
    }
  }
  
  show() {
    this.isShown = true;
  }

  hide() {
    this.hidden = true;
    setTimeout(() => {
      this.isShown = false;
      this.hidden = false;
    }, 600);
  }

  created() {
    this.$SplashScreen.$on(SPLASH_SCREEN_EVENTS.SPLASH_SCREEN_SHOW, this.show);
    this.$SplashScreen.$on(SPLASH_SCREEN_EVENTS.SPLASH_SCREEN_HIDE, this.hide);
  }

}